module.exports = new __parcel__URL__("insights.tpl.219b99b8.svg").toString();